import { pl, enUS } from "date-fns/locale";
import { isToday, format } from "date-fns";
import { t } from "i18next";

export const formatNotificationDate = (date: Date, language: "pl" | "en") => {
  const locale = language === "pl" ? pl : enUS;

  if (isToday(date)) {
    return `${t("common:today")} ${format(date, "HH:mm", { locale })}`;
  }

  const formatted = format(date, "MMM d, yyy HH:mm", { locale });

  if (language !== "pl") {
    return formatted;
  }

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
